<template>
  <div
    :class="['overlay', { 'is-active': createFoldersActive }]"
    :style="overlayStyles"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <EditOnline :hovered="hovered" />
    <div>
      <div class="overlay-bg" :style="overlayStyles"></div>

      <div class="title-container">
        <h3 class="text">{{ data.name }}</h3>
      </div>

      <div class="tags-container like-container-wrapper">
        <LikeTag
          :vector-id="data.id"
          :create-folders-active="createFoldersActive"
          @toggleCreateFolderActive="(state) => toggleCreateFolderActive(state)"
        />
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import LikeTag from '@/components/LikeTag';
import EditOnline from '@/components/Badges/EditOnline.vue';

export default {
  name: 'EditableOnlineOverlay',
  components: {
    LikeTag,
    EditOnline
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      createFoldersActive: false,
      hovered: false
    };
  },
  computed: {
    overlayStyles() {
      return `border-radius: ${this.data.borderRadius}px;`;
    }
  },
  methods: {
    toggleCreateFolderActive(state) {
      this.createFoldersActive = state;
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: 0.4s ease;
  z-index: 2;
  div {
    z-index: 100;
  }
  .overlay-downloaded {
    background: rgba(0, 0, 0, 0.65);
    height: 100%;
    position: absolute;
    bottom: 0;
    width: 100%;
    color: #ffffff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .check-icon {
      margin-right: 5px;
    }
  }
  &.is-active {
    z-index: 6;
  }
  &:hover {
    z-index: 5;
  }
  &:hover,
  &.is-active {
    .title-container,
    .like-container,
    .download-container,
    .premium-container,
    .attribute-container,
    .tags-container {
      opacity: 1;
    }
    .overlay-bg {
      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.3));
      height: 70%;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    .overlay-downloaded {
      background: unset;
      .check-icon,
      .downloaded-text {
        display: none;
      }
    }
  }
}
.like-container-wrapper {
  position: absolute;
  bottom: 10px;
  right: 0;
}

.attribute-container {
  transition: 0.4s ease;
  opacity: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  .text {
    float: left;
    margin-top: 10px;
    margin-left: 10px;
    padding: 2px 6px;
    background-color: white;
    border-radius: 2px;
    box-shadow: 0px 3px 6px #0000001a;
    -webkit-box-shadow: 0px 3px 6px #0000001a;
    -moz-box-shadow: 0px 3px 6px #0000001a;
    display: flex;
    font-size: 11px;
    color: black;
    width: max-content;
  }
}
.premium-container {
  opacity: 0;
  .text {
    margin: 2px 11px;
    opacity: 1;
  }
  .icon-container {
    width: 35px;
  }
}
.tags-container {
  opacity: 0;
}
.icon-container {
  height: 20px;
  position: absolute;
  right: 0;
  width: 38px;
  display: flex;
  align-content: center;
  top: 8px;
}
.icon-container > .icon {
  height: 100%;
  margin: auto;
}
.title-container {
  opacity: 0;
  position: absolute;
  bottom: 0;
  margin-left: 10px;
  margin-bottom: 10px;
  color: white;
  font-weight: 500;
  transition: 0.4s ease;
  width: 74%;
  h3 {
    font-size: 16px;
    margin-bottom: 0;
  }
}

@media all and (max-width: 767px) {
  .title-container {
    font-size: 15px;
  }
}
@media all and (max-width: 550px) {
  .title-container {
    font-size: 13px;
  }
}
</style>
